import { Operator } from '@procureai/query-builder';
import {
  ValueEditorNumberInput,
  ValueEditorNumberRange,
  ValueEditorNumberRangeProps,
} from '@procureai/query-builder-ui-mui';

type RenderPercentageEditorOptions = {
  operator: string;
  otherProps: {
    value?: any;
    onChange: (value: any) => void;
    [key: string]: any;
  };
};

/**
 * Renders a percentage value editor (0-100%) with proper transforms.
 * For BETWEEN operator: uses ValueEditorNumberRange with value transforms (0-1 ↔ 0-100)
 * For other operators: uses ValueEditorNumberInput
 */
export const renderPercentageEditor = ({ operator, otherProps }: RenderPercentageEditorOptions) => {
  const baseProps = { min: 0, max: 100, unit: '%' };

  if (operator === Operator.BETWEEN) {
    const rangeTransformProps: Pick<ValueEditorNumberRangeProps, 'valueFrom' | 'valueTo'> = {
      valueFrom: (value) => (value ? Math.round(value * 100) : value),
      valueTo: (value) => (value ? value / 100 : value),
    };
    return <ValueEditorNumberRange {...otherProps} {...baseProps} {...rangeTransformProps} />;
  }

  return <ValueEditorNumberInput {...otherProps} {...baseProps} />;
};
